// extracted by mini-css-extract-plugin
export default {"auctionTitleAndNavContainer":"AuctionTitleAndNavWrapper_auctionTitleAndNavContainer__FbkuP"};